import type React from 'react';

interface VendorDirectoryIconProps {
  color?: string;
  className?: string;
  width?: number;
  height?: number;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const VendorDirectoryIcon: React.FC<VendorDirectoryIconProps> = ({
  className = '',
  width = 20,
  height = 20,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.7292 9.71675V7.00923L10.1042 10.1342V16.4672C10.4285 16.5317 10.7088 16.7634 10.8159 17.1008C10.9725 17.5942 10.7 18.1208 10.2068 18.2775C9.86857 18.3849 9.5174 18.4387 9.16675 18.4387C8.67029 18.4387 8.17345 18.3314 7.71289 18.1164L7.51758 18.0175L2.51758 15.2844C1.41493 14.6815 0.7293 13.5247 0.729248 12.268V6.89936C0.729279 6.31241 0.881003 5.74845 1.15283 5.25141C1.16621 5.21944 1.18077 5.1872 1.198 5.1562C1.22648 5.10498 1.2584 5.057 1.29443 5.01338C1.59852 4.55024 2.01395 4.15835 2.51758 3.88301L7.51758 1.14985L7.71289 1.05097C8.6998 0.590235 9.85266 0.62327 10.8159 1.14985L15.8159 3.88301L16.0173 4.00264C16.4335 4.2684 16.7797 4.618 17.0427 5.0207C17.0767 5.06262 17.1084 5.10739 17.1355 5.1562C17.1527 5.18721 17.1673 5.21944 17.1807 5.25141C17.4525 5.74845 17.6042 6.31241 17.6042 6.89936V9.71675C17.6042 10.2345 17.1845 10.6542 16.6667 10.6542C16.149 10.6542 15.7292 10.2345 15.7292 9.71675ZM9.91626 2.79536C9.50765 2.57199 9.02403 2.54365 8.59668 2.71113L8.41724 2.79536L3.60767 5.42353L9.16675 8.51069L14.7246 5.42353L9.91626 2.79536ZM2.60425 12.268C2.6043 12.8392 2.91604 13.3649 3.41724 13.6389L8.22925 16.2683V10.1342L2.60425 7.00923V12.268Z"
        fill={color}
      />
      <path
        d="M16.9792 15.4162C16.9792 14.5533 16.2797 13.8537 15.4167 13.8537C14.5538 13.8537 13.8542 14.5533 13.8542 15.4162C13.8542 16.2792 14.5538 16.9787 15.4167 16.9787C16.2797 16.9787 16.9792 16.2792 16.9792 15.4162ZM18.8542 15.4162C18.8542 16.0245 18.6932 16.5941 18.416 17.0898L18.9959 17.6696L19.0605 17.7416C19.3607 18.1099 19.339 18.6521 18.9959 18.9953C18.6527 19.3385 18.1104 19.3601 17.7422 19.06L17.6702 18.9953L17.0903 18.4155C16.5947 18.6927 16.025 18.8537 15.4167 18.8537C13.5183 18.8537 11.9792 17.3147 11.9792 15.4162C11.9792 13.5177 13.5183 11.9787 15.4167 11.9787C17.3152 11.9787 18.8542 13.5177 18.8542 15.4162Z"
        fill={color}
      />
    </svg>
  );
};
